/**
 * Originally from:
 * https://github.com/tungd/react-catalyst/blob/master/src/catalyst/LinkedStateMixin.js
 *
 * @param {object}
 * @param {string}
 * @param {any}
 * @return {object}
 */
module.exports = function updateIn(obj, path, value) {
  var current = obj;
  var stack = path.split('.');

  if(typeof current === 'undefined') {
    current={}
  }

  while ( stack.length > 1 ) {
    current = current[stack.shift()];

    if(typeof current === 'undefined') {
      current={}
    }
  }

  /*if(typeof current === 'undefined') {
    current={}
  }*/

  current[stack.shift()] = value;



  return obj;
}
